import React from 'react';

// Line drawings of the devices a location has, in the portal's own hand: one
// stroke weight, a pale fill, no shadow. Presentation only.
function LabelPrinter({ wide }) {
  return <svg viewBox="0 0 96 72" className="xo-dev-drawing" role="presentation" aria-hidden="true">
    <path className="fill" d="M14 26c0-5 4-9 9-9h50c5 0 9 4 9 9v28c0 3-2 5-5 5H19c-3 0-5-2-5-5V26z" />
    <path d="M14 34h68" />
    <rect className="paper" x={wide ? 26 : 32} y="44" width={wide ? 44 : 32} height="20" rx="1.5" />
    <path d={wide ? 'M32 51h32M32 56h22' : 'M37 51h22M37 56h14'} />
    <path d="M24 44h48" />
    <rect x="58" y="22" width="14" height="8" rx="1.5" />
    <circle className="light" cx="26" cy="26" r="2" />
  </svg>;
}

function Scanner() {
  return <svg viewBox="0 0 96 72" className="xo-dev-drawing" role="presentation" aria-hidden="true">
    <path className="fill" d="M22 60c0-5 4-8 9-8h34c5 0 9 3 9 8v3H22v-3z" />
    <path className="fill" d="M40 52l7-22 12 4-6 18z" />
    <path className="fill" d="M41 10h26c5 0 8 3 8 8v6c0 4-3 7-7 7l-24-3c-4-1-7-4-7-8v-4c0-3 2-6 4-6z" />
    <path d="M70 15v12" />
    <path d="M78 14l7-3M79 21h8M78 28l7 3" className="beam" />
    <circle className="light" cx="48" cy="58" r="2" />
  </svg>;
}

export function DeviceDrawing({ category, purpose }) {
  if (category === 'scanner') return <Scanner />;
  return <LabelPrinter wide={purpose === 'shipping_labels'} />;
}

// Code 128, subset B: bar and space widths of each symbol, in modules.
const PATTERNS = ('212222 222122 222221 121223 121322 131222 122213 122312 132212 221213 221312 231212 112232 122132 122231 113222 123122 '
  + '123221 223211 221132 221231 213212 223112 312131 311222 321122 321221 312212 322112 322211 212123 212321 232121 111323 131123 131321 '
  + '112313 132113 132311 211313 231113 231311 112133 112331 132131 113123 113321 133121 313121 211331 231131 213113 213311 213131 311123 '
  + '311321 331121 312113 312311 332111 314111 221411 431111 111224 111422 121124 121421 141122 141221 112214 112412 122114 122411 142112 '
  + '142211 241211 221114 413111 241112 134111 111242 121142 121241 114212 124112 124211 411212 421112 421211 212141 214121 412121 111143 '
  + '111341 131141 114113 114311 411113 411311 113141 114131 311141 411131 211412 211214 211232 2331112').split(' ');
const START_B = 104;
const STOP = 106;

// The symbol values of a text in subset B, with its check symbol.
export function code128Values(value) {
  const symbols = Array.from(String(value), (character) => {
    const symbol = character.charCodeAt(0) - 32;
    if (symbol < 0 || symbol > 94) throw new Error('CODE128_UNSUPPORTED_CHARACTER');
    return symbol;
  });
  const check = symbols.reduce((sum, symbol, index) => sum + symbol * (index + 1), START_B) % 103;
  return [START_B, ...symbols, check, STOP];
}

// A barcode to scan off the screen, used to try a scanner out.
export function Code128({ value, height = 64, module = 2, label }) {
  const widths = code128Values(value).flatMap(symbol => Array.from(PATTERNS[symbol], Number));
  const quiet = 10 * module;
  const bars = [];
  let x = quiet;
  widths.forEach((width, index) => {
    if (index % 2 === 0) bars.push(<rect key={index} x={x} y="0" width={width * module} height={height} />);
    x += width * module;
  });
  return <svg className="xo-dev-barcode" viewBox={`0 0 ${x + quiet} ${height}`} width={x + quiet} height={height} role="img" aria-label={label}>
    <rect x="0" y="0" width={x + quiet} height={height} fill="#fff" />
    <g fill="#000">{bars}</g>
  </svg>;
}

export { PATTERNS };
